import React from 'react';
import {inject, observer} from 'mobx-react';
import {IMG_PATH} from '../../constant';

@inject(({store}) => ({
    amorous: store.renderData.amorous,
    showPopup: store.showPopup
}))
@observer
class Amorous extends React.Component {
    render() {
        const {showPopup, amorous: {img = {}, video = {}}} = this.props;
        if (!video.touch) {
            return null;
        }
        return <div className="module m-amorous">
            <img className="img-bg" src={`${IMG_PATH}/video_bgNew.png`} />
            <div className="m-amo-video" data-sk-eid="video" onClick={() => showPopup(video.touch)}>
                <div className="video-box">
                    <img src={img.touch} alt="" />
                    <span className="iconfont play">&#xe3a8;</span>
                </div>
            </div>
        </div>
        ;
    }
}

export default Amorous;